import { salesOrderItemSummaryHeadline, type SalesOrderItemSummary } from "@/lib/sales-order-list-summary";

export function SalesOrderItemSummaryView({
  summary,
  compact = false,
}: {
  summary: SalesOrderItemSummary;
  compact?: boolean;
}) {
  if (summary.empty) {
    return <span className="text-sm text-slate-400">—</span>;
  }
  const headline = salesOrderItemSummaryHeadline(summary);
  return (
    <div className={compact ? "min-w-0" : "min-w-0 max-w-xs"} title={summary.tooltip}>
      <div className="text-sm font-medium text-slate-800 truncate">{headline}</div>
      {summary.extraCount === 0 && (
        <>
          {summary.variant ? <div className="text-xs text-slate-500 truncate">{summary.variant}</div> : null}
          <div className="text-xs text-slate-400 font-mono truncate">
            {[summary.sku, summary.qtyLabel].filter(Boolean).join(" · ")}
          </div>
        </>
      )}
    </div>
  );
}
